import { Component, OnInit, Input } from "@angular/core";
import { TopNavBtn } from "../../classes/navbar";
import { KpiService } from "../../kpi/kpi.service";
import { WindowRef } from "../../window/WindowRef";
import { MatDialog } from "@angular/material/dialog";
import { ChartIconButtonComponent } from "../chart-icon-button/chart-icon-button.component";

@Component({
  selector: "top-nav-btn",
  templateUrl: "./top-nav-btn.component.html",
  styleUrls: ["./top-nav-btn.component.scss"],
})
export class TopNavBtnComponent
  extends ChartIconButtonComponent
  implements OnInit {
  @Input() btnDetails: TopNavBtn;
  @Input() isBolded: boolean;

  constructor(
    public winRef: WindowRef,
    public kpiService: KpiService,
    public dialog: MatDialog
  ) {
    super(winRef, kpiService, dialog);
  }

  ngOnInit() {}

  trackEvent(title) {
    this.kpiService.trackNavButtonClicked(title).subscribe();
  }

  openOtherReportsLink(url) {
    this.kpiService.trackNavButtonClicked("Other Reports").subscribe();
    this.url = url;
    this.selectBtn("otherReports");
  }

  clickBtn(btnDetails) {
    if (btnDetails.otherReportsUrl) {
      this.openOtherReportsLink(btnDetails.otherReportsUrl);
    } else if (btnDetails.title == "Upgrade") {
      this.selectBtn("upgrade");
    } else {
      this.trackEvent(
        btnDetails.ninthGradeSuccessUrl
          ? "Ninth Grade Success"
          : btnDetails.title
      );
    }
  }
}
